import { useAuth } from "@/providers/auth-provider";
import { useMerchant } from "@/providers/MerchantProvider";

export const useMerchantName = () => {
  const { user } = useAuth();
  const merchantId = useMerchant();
  return user?.merchants?.find((m) => m.id === merchantId)?.name;
};
